import { InvoiceDocumentType } from '../../enums/invoiceDocumentType'
import type { RelatedInvoice } from '../../types/relatedInvoice'

// The BE contract for a quote's relatedInvoices does not always populate documentType on draft
// entries - only invoiceDraftId + billingStage.
export const getRelatedInvoiceDocumentType = (relatedInvoice: RelatedInvoice): InvoiceDocumentType =>
  relatedInvoice.documentType ??
  (relatedInvoice.invoiceDraftId ? InvoiceDocumentType.InvoiceDraft : InvoiceDocumentType.Invoice)
